import ConstituentDto from "../Models/ConstituentDto";
import FilteredZooConstituentDto from "../Models/FilteredZooConstituentDto";

export default () => {
    const getMemberships = async (fetchBase : string, includeInactiveMembershipLevels: boolean = false, includeAllFuture: boolean = false) : Promise<FilteredZooConstituentDto> => {
        try {
            const response = await fetch(`${fetchBase}/api/tessitura/member-info?includeInactiveMembershipLevels=${includeInactiveMembershipLevels}&includeAllFuture=${includeAllFuture}`, {
                'credentials': 'include',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();
            // Return the populated map
            return data;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    const getPrimaryHousehold = async (fetchBase: string): Promise<ConstituentDto> => {
        try {
            const response = await fetch(`${fetchBase}/api/tessitura/primary-household`, {
                'credentials': 'include',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();
            // Return the populated map
            return data;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }
    return { getMemberships, getPrimaryHousehold };
}